export const METRIPORT_PRIMARY = "#748df0";
export const METRIPORT_PRIMARY_FADED = "#879ced";
export const METRIPORT_PRIMARY_FADED_HOVER = "#e3edfb";
export const METRIPORT_PRIMARY_HOVER = "#8da5f5";
export const METRIPORT_PRIMARY_ACTIVE = "#6380ec";
export const METRIPORT_PRIMARY_FADED_CSS = {
  r: 135,
  g: 156,
  b: 237,
};

// https://mycolor.space/?hex=%23748DF0&sub=1
export const METRIPORT_GREEN = "#498380";
export const METRIPORT_DARK_GREEN = "#005452";
export const METRIPORT_PURPLE = "#975da5";
